import { useEffect, useRef } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

// Vini con scheda corretta e descrizione scritta su dati vecchi: la riscrive in automatico, poi ricarica la lista
export const useDescrizioniDaAggiornare = (vini, getAuthHeaders, onFatto) => {
  const avviato = useRef(false);
  const timer = useRef(null);
  const fatto = useRef(onFatto);
  fatto.current = onFatto;

  useEffect(() => () => clearTimeout(timer.current), []);

  useEffect(() => {
    const ids = (vini || []).filter((v) => v.descrizione_da_aggiornare).map((v) => v.id);
    if (!ids.length || avviato.current) return;
    avviato.current = true;
    const controlla = async () => {
      try {
        const r = await axios.get(`${API}/api/vini-descrizioni/stato`, { headers: getAuthHeaders() });
        if (r.data.job?.stato === 'in_corso') { timer.current = setTimeout(controlla, 6000); return; }
        toast.success('Descrizioni aggiornate con i dati verificati');
        fatto.current();
      } catch { /* riprova al prossimo caricamento */ }
    };
    axios.post(`${API}/api/vini-descrizioni/avvia`, { ids }, { headers: getAuthHeaders() })
      .then(() => { toast.info(`Riscrivo ${ids.length} descrizioni con i dati corretti…`); timer.current = setTimeout(controlla, 6000); })
      .catch(() => { avviato.current = false; });
  }, [vini, getAuthHeaders]);
};
